import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36aad1b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mxa-message-error-top",
  "data-test": "data-top"
}

import { PropType, computed } from 'vue'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
  // エラー情報
  error: {
    type: Object as PropType<ErrorMsgState>,
    default: () => ({ data: [] }),
  },
},
  setup(__props) {

const props = __props

log.trace(`ErrorMessage setup start.`)
// プロパティ定義


// データ有無の判定
const isData = computed(() => props.error.data.length > 0)

log.trace(`ErrorMessage setup end.`)

return (_ctx: any,_cache: any) => {
  return (_unref(isData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.error.data, (error, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mxa-message-error-body",
            "data-test": "data-body"
          }, _toDisplayString(_ctx.$t(error.key, error.arg)), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})